var _styled;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { MEDIA_QUERIES, SPACING, SITE_WIDTH } from '@govuk-react/constants';
var OuterContainer = styled('div')({
  paddingTop: SPACING.SCALE_5,
  textAlign: 'center'
});
var InnerContainer = styled('div')((_styled = {
  maxWidth: SITE_WIDTH,
  marginLeft: SPACING.SCALE_3,
  marginRight: SPACING.SCALE_3,
  textAlign: 'left'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  marginLeft: SPACING.SCALE_5,
  marginRight: SPACING.SCALE_5
}, _styled['@media only screen and (min-width:1020px)'] = {
  margin: '0 auto'
}, _styled));
/**
 *
 * Provides a container which aligns to the topNav component,
 * is centered, and provides top padding.
 *
 *
 * ### Usage
 *
 * Example
 * * https://codesandbox.io/s/x917knwm4z
 *
 * Simple
 * ```jsx
 * import GridRow from '@govuk-react/grid-row';
 * import GridCol from '@govuk-react/grid-col';
 *
 * <Main>
 *   <GridRow>
 *     <GridCol>
 *       ...
 *     </GridCol>
 *   </GridRow>
 * </Main>
 * ```
 *
 * ### TODO
 * - Implement the 1020px min-width MQ to constants
 *
 */

var Main = function Main(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(OuterContainer, props, React.createElement(InnerContainer, null, children));
};

Main.defaultProps = {
  children: undefined
};
export default Main;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/main/es/index.js
// module id = 270
// module chunks = 0